import {useEffect, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
// import ReactPaginate from 'react-paginate'
import './Package.css'
import { PackagePost, PackageUpdate, Packagee } from '../../models/Package'
import PackageService from '../../../api/super-admin/PackageService'

interface Errors {
  title: string;
  duration: string;
  price: string;
  discount_amount: string;
  user_limit: string;
  sms_sent_limit: string;
  email_sent_limit: string;
}

function Package() {

  const [showAddEditPopup, setShowAddEditPopup] = useState<boolean>(false);
  const [showDetailsPopup, setShowDetailsPopup] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  
  const [packageList, setPackageList] = useState<Packagee[]>([] as Packagee[]);
  const [formData, setFormData] = useState<any>({
    id: undefined,
    title: '',
    duration: undefined,
    price: undefined,
    discount_amount: undefined,
    discount_percentage: undefined,
    user_limit: undefined,
    sms_sent_limit: undefined,
    email_sent_limit: undefined,
    status: undefined
  })
  const [formErrors, setFormErrors] = useState<Errors>({ title: '', duration: '', price: '', discount_amount: '', user_limit: '', sms_sent_limit: '', email_sent_limit: '' });
  
  // const [offset, setOffset] = useState<number>(0)
  // const [limit, setLimit] = useState<number>(10)
  // const [totalPages, setTotalPages] = useState<number>(0)

  useEffect(() => {
    getPackageList()
  }, [])

  const getPackageList = () => {
    PackageService.getPackageList().then(
      (res: any) => {
        if (res?.data?.success) {
          setPackageList(res?.data?.data)
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
          setPackageList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
    // let data: any = {
    //   limit: limit,
    //   offset: offset,
    // }
    // PackageService.getPackageList(data).then(
    //   (res: any) => {
    //     if (res?.data?.success) {
    //       setPackageList(res?.data?.data)
    //       setTotalPages(Math.ceil(res?.data?.count / limit))
    //     } else {
    //       toast.error(res?.data?.message, {theme: 'dark'})
    //       setPackageList([])
    //     }
    //   },
    //   (err: any) => {
    //     toast.error(err?.response?.data?.message, {theme: 'dark'})
    //   }
    // )
  }

  // const handlePageChange = (selected: any) => {
  //   const newOffset = selected === 0 ? 0 : selected * limit
  //   let data = {
  //     limit: limit,
  //     offset: newOffset,
  //   }
  //   PackageService.getPackageList(data).then(
  //     (res: any) => {
  //       if (res?.data?.success) {
  //         setPackageList(res?.data?.data)
  //         setTotalPages(Math.ceil(res?.data?.count / limit))
  //         setOffset(newOffset)
  //       } else {
  //         toast.error(res?.data?.message, {theme: 'dark'})
  //         setPackageList([])
  //       }
  //     },
  //     (err: any) => {
  //       toast.error(err?.response?.data?.message, {theme: 'dark'})
  //     }
  //   )
  // }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {name, value} = e.target
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }))
  }

  const clearFormData = () => {
    setFormData({
      id: undefined,
      title: '',
      duration: undefined,
      price: undefined,
      discount_amount: undefined,
      discount_percentage: undefined,
      user_limit: undefined,
      sms_sent_limit: undefined,
      email_sent_limit: undefined,
      status: undefined
    })
  }

  const handleAdd = () => {
    clearFormData()
    setIsEdit(false)
    setShowAddEditPopup(true)
  }

  const handleViewDetails = (id: number) => {
    PackageService.getPackageDetails(id).then(
      (res: any) => {
        if (res?.data?.success) {
          const packagee: Packagee = res?.data?.data;
          setFormData({
            title: packagee.title,
            duration: packagee.duration,
            price: packagee.price,
            discount_amount: packagee.discount_amount,
            discount_percentage: packagee.discount_percentage,
            user_limit: packagee.user_limit,
            sms_sent_limit: packagee.sms_sent_limit,
            email_sent_limit: packagee.email_sent_limit,
            status: packagee.status
          })
          setShowDetailsPopup(true)
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  const handleEdit = (packagee: Packagee) => {
    setFormData({
      id: packagee.id,
      title: packagee.title,
      duration: packagee.duration,
      price: packagee.price,
      discount_amount: packagee.discount_amount,
      user_limit: packagee.user_limit,
      sms_sent_limit: packagee.sms_sent_limit,
      email_sent_limit: packagee.email_sent_limit,
    })
    setIsEdit(true);
    setShowAddEditPopup(true)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    // Clear previous errors
    setFormErrors({ title: '', duration: '', price: '', discount_amount: '', user_limit: '', sms_sent_limit: '', email_sent_limit: '' });

    // Validation checks
    let errors: Errors = {
      title: '',
      duration: '',
      price: '',
      discount_amount: '',
      user_limit: '',
      sms_sent_limit: '',
      email_sent_limit: ''
    };

    let hasErrors = false;
  
    if (!formData.title.trim()) {
      errors.title = 'Title is required';
      hasErrors = true;
    }
  
    if (!formData.duration) {
      errors.duration = 'Duration is required';
      hasErrors = true;
    }
    else if (formData.duration < 1 || formData.duration > 24) {
      errors.duration = 'Duration must be between 1 and 24';
      hasErrors = true;
    }
  
    if (!formData.price) {
      errors.price = 'Price is required';
      hasErrors = true;
    }
    else if (formData.price < 0) {
      errors.price = 'Price must be greater than or equal to 0';
      hasErrors = true;
    }
  
    if (!formData.discount_amount) {
      errors.discount_amount = 'Discount amount is required';
      hasErrors = true;
    }
    else if (formData.discount_amount < 0) {
      errors.discount_amount = `Discount amount must be greater than or equal to 0`;
      hasErrors = true;
    }
    else if (+formData.discount_amount > +formData.price) {
      errors.discount_amount = 'Discount amount must be less than or equal to price';
      hasErrors = true;
    }
  
    if (!formData.user_limit) {
      errors.user_limit = 'User limit is required';
      hasErrors = true;
    }
    else if (formData.user_limit < 1) {
      errors.user_limit = 'User limit must be greater than or equal to 1';
      hasErrors = true;
    }
  
    if (!formData.sms_sent_limit) {
      errors.sms_sent_limit = 'SMS sent limit is required';
      hasErrors = true;
    }
    else if (formData.sms_sent_limit < 0) {
      errors.sms_sent_limit = 'SMS sent limit must be greater than or equal to 0';
      hasErrors = true;
    }
  
    if (!formData.email_sent_limit) {
      errors.email_sent_limit = 'Email sent limit is required';
      hasErrors = true;
    }
    else if (formData.email_sent_limit < 0) {
      errors.email_sent_limit = 'Email sent limit must be greater than or equal to 0';
      hasErrors = true;
    }
  
    if (hasErrors) {
      setFormErrors(errors);
      return;
    } 
    

    if (!isEdit) {      
      let data: PackagePost = {
        title: formData?.title,
        duration: formData?.duration,
        price: formData?.price,
        discount_amount: formData?.discount_amount,
        user_limit: formData?.user_limit,
        sms_sent_limit: formData?.sms_sent_limit,
        email_sent_limit: formData?.email_sent_limit,
      }
      PackageService.addPackage(data).then(
        (res: any) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})            
            setShowAddEditPopup(false)
            clearFormData()
            getPackageList()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
    }
    else {
      let data: PackageUpdate = {
        id: formData?.id!,
        title: formData?.title,
        duration: formData?.duration,
        price: formData?.price,
        discount_amount: formData?.discount_amount,
        user_limit: formData?.user_limit,
        sms_sent_limit: formData?.sms_sent_limit,
        email_sent_limit: formData?.email_sent_limit,
      }
      PackageService.updatePackage(data).then(
        (res: any) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})            
            setShowAddEditPopup(false)
            clearFormData()
            getPackageList()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
    }
  }

  const handleDelete = (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        PackageService.deletePackage(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
              getPackageList()
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    })
  }

  const handleStatusToggle = (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to change the status?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, change it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        PackageService.changePackageStatus(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
              getPackageList()
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    })
  }

  return (
    <>
      <div className='text-lg-end'>
        <button type='button' className='btn btn-primary px-5 py-3' onClick={handleAdd}>
          + Add Package
        </button>
      </div>
      {/* Table */}
      <div className='col-lg-12' style={{marginTop: 25}} />
      <div className='mb-5'>
        <div className='table-responsive'>
          <div className='d-flex justify-content-between w-100 p-3 pb-2'>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Title</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Duration</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Price</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Discount Amount</span>
            </td>
            <td className='w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Status</span>
            </td>
            <td className='text-end w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Action</span>
            </td>
          </div>
          {packageList.map((packagee: Packagee, index: number) => (
            (packagee.status === 1 || packagee.status === 2) &&
            <div
              className='p-3 py-2 mb-2 bg-white d-flex justify-content-between w-100'
              key={index}
              style={{marginBottom: 20, borderRadius: 5}}
            >
              <td className='d-flex w-lg-25'>
                <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                  {packagee.title}
                </span>
              </td>
              <td className='d-flex w-lg-25'>
                <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                  {packagee.duration} Month
                </span>
              </td>
              <td className='d-flex w-lg-25'>
                <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                  {packagee.price}
                </span>
              </td>
              <td className='d-flex w-lg-25'>
                <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                  {packagee.discount_amount}
                </span>
              </td>
              <td className='d-flex w-lg-25'>
                <span className={`fw-bold d-block fs-5 d-flex align-items-center ${packagee.status===1? 'text-success' : 'text-danger'}`}>
                  {packagee.status === 1 ? 'Active' : 'In-active'}
                </span>
              </td>
              <td className='d-flex justify-content-end w-lg-25'>
                <button
                  type='button'
                  onClick={() => handleViewDetails(packagee.id)}
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  title='Details'
                >
                  <KTSVG path='/media/icons/duotune/general/detail.svg' className='svg-icon-3' />
                </button>
                <button
                  type='button'
                  onClick={() => handleEdit(packagee)}
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  title='Edit'
                >
                  <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                </button>
                <button
                  onClick={() => handleDelete(packagee?.id)}
                  type='button'
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  title='Delete'
                >
                  <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                </button>
                <div className='d-flex justify-content-end flex-shrink-0 mx-1'>
                  {packagee.status === 1 && (
                    <div className='d-flex align-items-center' data-bs-toggle='tooltip' data-bs-placement='top' title='Toggle Status'>
                      <button
                        className='status-holder active-status'
                        onClick={() => handleStatusToggle(packagee.id)}
                      >
                        <div className='d-flex align-items-center justify-content-end'>
                          <div className='active-user active-status-light'></div>
                        </div>
                      </button>
                    </div>
                  )}
                  {packagee.status === 2 && (
                    <div className='d-flex align-items-center' data-bs-toggle='tooltip' data-bs-placement='top' title='Toggle Status'>
                      <button
                        className='status-holder pending-status'
                        onClick={() => handleStatusToggle(packagee.id)}
                      >
                        <div className='d-flex align-items-center'>
                          <div className='active-user pending-status-light'></div>
                        </div>
                      </button>
                    </div>
                  )}
                </div>
              </td>
            </div>
          ))}
        </div>
      </div>
      {/* Pagination */}
      {/* {totalPages > 0 && (
        <ReactPaginate
          previousLabel='Previous'
          nextLabel='Next'
          breakLabel='...'
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={(selected) => handlePageChange(selected.selected)}
          containerClassName='pagination'
          activeClassName='active'
        />
      )} */}
      {/* Add / Edit Popup */}
      {showAddEditPopup && (
        <div className='modal' style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
          <div className='modal-dialog modal-lg modal-dialog-centered'>
            <div className='modal-content container'>
              <div className='d-flex flex-row align-items-center justify-content-between w-100 mx-3'>
                <h5 style={{marginLeft:20}} className='modal-title'>{isEdit ? 'Update Package' : 'Add Package'}</h5>
                <button className='btn btn-close' onClick={() => {
                  setFormErrors({ title: '', duration: '', price: '', discount_amount: '', user_limit: '', sms_sent_limit: '', email_sent_limit: '' })
                  setShowAddEditPopup(false)
                }}></button>
              </div>
              <div className='modal-body users'>
                {/* Form */}
                <form onSubmit={handleSubmit}>
                  <div className='row mb-3'>
                    <div className='form-group col-6'>
                      <label htmlFor='fullName'>Title</label>
                      <input
                        type='text'
                        id='title'
                        name='title'
                        className={`form-control ${formErrors.title && 'is-invalid'}`}
                        value={formData.title}
                        onChange={handleInputChange}
                      />
                      {formErrors.title && <div className='invalid-feedback'>{formErrors.title}</div>}
                    </div>
                    <div className='form-group col-6'>
                      <label htmlFor='fullName'>Duration</label>
                      <input
                        type='number'
                        id='duration'
                        name='duration'
                        className={`form-control ${formErrors.duration && 'is-invalid'}`}
                        value={formData.duration}
                        onChange={handleInputChange}
                      />
                      {formErrors.duration && <div className='invalid-feedback'>{formErrors.duration}</div>}
                    </div>
                    <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>Price</label>
                      <input
                        type='number'
                        id='price'
                        name='price'
                        className={`form-control ${formErrors.price && 'is-invalid'}`}
                        value={formData.price}
                        onChange={handleInputChange}
                      />
                      {formErrors.price && <div className='invalid-feedback'>{formErrors.price}</div>}
                    </div>                    
                    <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>Discount Amount</label>
                      <input
                        type='number'
                        id='discount_amount'
                        name='discount_amount'
                        className={`form-control ${formErrors.discount_amount && 'is-invalid'}`}
                        value={formData.discount_amount}
                        onChange={handleInputChange}
                      />
                      {formErrors.discount_amount && <div className='invalid-feedback'>{formErrors.discount_amount}</div>}
                    </div>
                    <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>User Limit</label>
                      <input
                        type='number'
                        id='user_limit'
                        name='user_limit'
                        className={`form-control ${formErrors.user_limit && 'is-invalid'}`}
                        value={formData.user_limit}
                        onChange={handleInputChange}
                      />
                      {formErrors.user_limit && <div className='invalid-feedback'>{formErrors.user_limit}</div>}
                    </div>                    
                    <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>SMS Sent Limit</label>
                      <input
                        type='number'
                        id='sms_sent_limit'
                        name='sms_sent_limit'
                        className={`form-control ${formErrors.sms_sent_limit && 'is-invalid'}`}
                        value={formData.sms_sent_limit}
                        onChange={handleInputChange}
                      />
                      {formErrors.sms_sent_limit && <div className='invalid-feedback'>{formErrors.sms_sent_limit}</div>}
                    </div>
                    <div className='form-group col-6 mt-2'>
                    <label htmlFor='fullName'>Email Sent Limit</label>
                      <input
                        type='number'
                        id='email_sent_limit'
                        name='email_sent_limit'
                        className={`form-control ${formErrors.email_sent_limit && 'is-invalid'}`}
                        value={formData.email_sent_limit}
                        onChange={handleInputChange}
                      />
                      {formErrors.email_sent_limit && <div className='invalid-feedback'>{formErrors.email_sent_limit}</div>}
                    </div>
                  </div>
                  <div className='text-end'>
                    <button type='submit' className='btn btn-primary' style={{borderRadius: 25}}>
                      {isEdit ? 'Update' : 'Add'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Details Popup */}
      {showDetailsPopup && (
        <div className='modal' style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
          <div className='modal-dialog modal-lg modal-dialog-centered'>
            <div className='modal-content container'>
              <div className='d-flex flex-row align-items-center justify-content-between w-100 mx-3'>
                <h5 style={{marginLeft:20}} className='modal-title'>Details</h5>
                <button className='btn btn-close' onClick={() => {
                  setShowDetailsPopup(false)
                  clearFormData()
                }}></button>
              </div>
              <div className='modal-body users'>
                {/* Form */}
                <form onSubmit={handleSubmit}>
                  <div className='row mb-3'>
                    <div className='form-group col-6'>
                      <label htmlFor='fullName'>Title</label>
                      <input
                        className='form-control'
                        value={formData.title}
                        disabled
                      />
                    </div>
                    <div className='form-group col-6'>
                      <label htmlFor='fullName'>Duration</label>
                      <input
                        className='form-control'
                        value={formData.duration}
                        disabled
                      />
                    </div>
                    <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>Price</label>
                      <input
                        className='form-control'
                        value={formData.price}
                        disabled
                      />
                    </div>                    
                    <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>Discount Amount</label>
                      <input
                        className='form-control'
                        value={formData.discount_amount}
                        disabled
                      />
                    </div>
                    <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>Discount Percentage</label>
                      <input
                        className='form-control'
                        value={formData.discount_percentage + ' %'}
                        disabled
                      />
                    </div>
                    <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>User Limit</label>
                      <input
                        className='form-control'
                        value={formData.user_limit}
                        disabled
                      />
                    </div>                    
                    <div className='form-group col-6 mt-2'>
                      <label htmlFor='fullName'>SMS Sent Limit</label>
                      <input
                        className='form-control'
                        value={formData.sms_sent_limit}
                        disabled
                      />
                    </div>
                    <div className='form-group col-6 mt-2'>
                    <label htmlFor='fullName'>Email Sent Limit</label>
                      <input
                        className='form-control'
                        value={formData.email_sent_limit}
                        disabled
                      />
                    </div>
                    <div className='form-group col-6 mt-2'>
                    <label htmlFor='fullName'>Status</label>
                      <input
                        className='form-control'
                        value={formData.status===1? 'Active' : 'In-active'}
                        disabled
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Package
